import { Component, OnInit, HostListener } from '@angular/core';
import { CompanyGroup } from '../../../models/CompanyGroup.model';
import { CompanyGroupSearch } from "../../../models/CompanyGroupSearch.model";
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import { DropDownList } from '../../../models/DropDownList.model';
// import { Industry } from '../../../models/Industry.model';
// import { IndustriesService } from '../../../services/industries.service';
import { Json2csvService } from "../../../services/json2csv.service";
import * as moment from "moment";
import  *  as _ from "lodash";

import { CompanyInventorySearch } from '../../../models/CompanyInventorySearch';
import { CompanyInventoryService } from '../../../services/companyInventory.service';
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
// import { ExcellenceCenter } from '../../../models/ExcellenceCenter.model';
// import { ExcellenceCentersService } from '../../../services/excellenceCenters.service';
import { CompaniesService } from '../../../services/companies.service';
import { CompanyInventoryModel, InventoryContractType } from '../../../models/CompanyInventory.model';
import { ContractTypesService } from '../../../services/contractTypes.service';

moment.locale('pt-br');
@Component({
  selector: 'app-companyInventory',
  templateUrl: './companyInventory.component.html',
  styleUrls: ['./companyInventory.component.scss']
})
export class CompanyInventoryComponent implements OnInit {

  itemsPerPage: number[] = [10, 50, 100];
  totalItems: number = 0;
  currentPage: number = 1;

  customer: CompanyInventoryModel[] = new Array<CompanyInventoryModel>();
  companyInventory: CompanyInventoryModel[] = new Array<CompanyInventoryModel>();

  dropDownListCompanyGroups: DropDownList[] = new Array<DropDownList>();
  selectedCompanyGroupsItems: DropDownList[] = new Array<DropDownList>();
  dropDownCompanyGroupsSettings = {};

//   dropDownListExcellenceCenters: DropDownList[] = new Array<DropDownList>();
//   selectedExcellenceCentersItems: DropDownList[] = new Array<DropDownList>();
//   dropDownExcellenceCentersSettings = {};

//   excellenceCenters: Array<ExcellenceCenter> = [];
//   allCenters: Array<ExcellenceCenter> = [];

//   dropDownListIndustries: DropDownList[] = new Array<DropDownList>();
//   selectedIndustriesItems: DropDownList[] = new Array<DropDownList>();
//   dropDownIndustriesSettings = {};

  dropDownListCustomers: DropDownList[] = new Array<DropDownList>();
  selectedCustomersItems: DropDownList[] = new Array<DropDownList>();
  dropDownCustomersSettings = {};

  companyIntentorySearchFactory = new CompanyInventorySearch();
  companyGroups: CompanyGroup[] = new Array<CompanyGroup>();
//   industry: Industry[] = new Array<Industry>();
  companyGroupSearchModel;
  commonHelper: CommonHelper = new CommonHelper();
  companyInventorySearchModel;
  user;
  loading: boolean;

  contractTypes: InventoryContractType[] = new Array<InventoryContractType>();
  readjustmentQuoeficient: Array<number> = [];

  constructor(private companiesInventoryService: CompanyInventoryService,
    private json2csvService: Json2csvService,
    private companiesService: CompaniesService,
    private contractTypesService: ContractTypesService,
    private projectFinancialService: ProjectFinancialService,
    // private industriesService: IndustriesService,
    // private excellenceCentersService: ExcellenceCentersService,
    private localStorage: LocalStorage) { }

  async ngOnInit() {
    this.loading = true;
    this.user = this.localStorage.retrieve('user');
    this.companyInventorySearchModel = this.companyIntentorySearchFactory.newSearch();
    this.companyInventorySearchModel = this.localStorage.retrieve('company-inventory')?this.localStorage.retrieve('company-inventory'):new CompanyInventorySearch();

    let response = await this.projectFinancialService.getProjectsAndCustomers();
    this.customer = response.customers;
    this.customer = _.sortBy(this.customer,"name");
    // this.industry = await this.industriesService.getAll();
    this.companyGroupSearchModel = new CompanyGroupSearch();
    this.companyGroupSearchModel.allItems = true;

    // const typeOneCenters = await this.excellenceCentersService.getAll();
    // this.excellenceCenters = typeOneCenters.filter(ec => ec.type == 1);
    // this.excellenceCenters = _.orderBy(this.excellenceCenters, [sup => sup.name.toUpperCase()]);

    this.companyGroups = await this.companiesService.searchCompanyGroups(this.companyGroupSearchModel);
    this.readjustmentQuoeficient = this.commonHelper.getAllReadjustmentQuoeficientGroups();

    this.dropDownListCompanyGroups = this.commonHelper.getDropDownListItems(this.companyGroups, "_id", "name");
    this.dropDownCompanyGroupsSettings = this.commonHelper.getDropDownSettings(true, 'Grupo de empresa', false, 'Marcar todas os grupos', 'Desmarcar todas os grupos', true,null, '');

    // this.dropDownListIndustries = this.commonHelper.getDropDownListItems(this.industry, "_id", "name");
    // this.dropDownIndustriesSettings = this.commonHelper.getDropDownSettings(false, 'Selecione um Setor', false, 'Marcar todas os grupos', 'Desmarcar todas os grupos', true,null, '');

    this.dropDownListCustomers = this.commonHelper.getDropDownListItems(this.customer, "_id", "name");
    this.dropDownCustomersSettings = this.commonHelper.getDropDownSettings(false, 'Clientes', false, 'Marcar todos os clientes', 'Desmarcar todos os clientes', true,null, '');

    // this.dropDownListExcellenceCenters = this.commonHelper.getDropDownListItems(this.excellenceCenters, '_id', 'name');
    // this.dropDownExcellenceCentersSettings = this.commonHelper.getDropDownSettings(false, 'Centro de Excelência', true, 'Marcar todos os centros de excelência', 'Desmarcar todos os centros de excelência', true, null , '');

    this.populateContractTypes();

    await this.searchCompanies(1);
    this.loading = false;
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode === 13) {

      this.searchCompanies(1);

    }
  }



  async searchCompanies(page?: number, toexport?: boolean) {
      let limit, skip;
      this.loading = true;
      this.currentPage = page ? page : 1;
      this.companyInventorySearchModel.skip = (this.currentPage - 1) * this.companyInventorySearchModel.limit;
      if (toexport) {
        limit = this.companyInventorySearchModel.limit;
        skip = this.companyInventorySearchModel.skip;
        delete this.companyInventorySearchModel.skip;
        delete this.companyInventorySearchModel.limit;
     }

      this.companyInventorySearchModel.customer = this.selectedCustomersItems.map(cg => cg.id);
      this.companyInventorySearchModel.companyGroup = this.selectedCompanyGroupsItems.map(cg => cg.id);
    //   this.companyInventorySearchModel.excellenceCenter = this.selectedExcellenceCentersItems.map(cg => cg.id);
    //   this.companyInventorySearchModel.industry = this.selectedIndustriesItems.map(cg => cg.id);
      this.companyInventorySearchModel.contractType = this.companyInventorySearchModel.contractType ? this.companyInventorySearchModel.contractType._id : ""
      this.companyInventory = await this.companiesInventoryService.searchCompanies(this.companyInventorySearchModel);

      this.totalItems = this.companyInventorySearchModel.totalItems

      if (toexport) {
          this.companyInventorySearchModel.limit = limit;
          this.companyInventorySearchModel.skip = skip;
      }

      this.localStorage.persist('company-inventory',this.companyInventorySearchModel);

      this.loading = false;
  }

  async populateContractTypes(): Promise<void> {
    this.contractTypes = (await this.contractTypesService.getAll())
        .filter(contract => contract.active);
  }

  isActive(active: boolean) {
    return active ? "badge-success" : "badge-danger";
  }

  isActiveText(active: boolean) {
    return active ? "Ativo" : "Inativo";
  }

  async export() {
    await this.searchCompanies(1, true);
      if(!this.companyInventory) {
        return;
      }
      this.json2csvService.export(
      this.companyInventory.map(inventoryShow => {
        return {
          "Nome do Cliente": inventoryShow.customer ? inventoryShow.customer.name : "-",
          "Grupo de empresa": inventoryShow.companyGroup ? inventoryShow.companyGroup.name:"-",
          "Projeto": inventoryShow.project ? inventoryShow.project.name : "-",
        //   "Centro de Excelência": inventoryShow.excellenceCenter ? inventoryShow.excellenceCenter.name : "-",
        //   "Setor": inventoryShow.industry? inventoryShow.industry.name : "-",
          "Tipo de Contrato": inventoryShow.contractType ? inventoryShow.contractType.name : "-",
          "Data de Início": inventoryShow.startDate ? moment(inventoryShow.startDate).format("L") : "-",
          "Prazo Final Indeterminado": inventoryShow.dateEnd && inventoryShow.dateEnd.indefinitePeriod ? "SIM" : "NÃO",
          "Data Final": inventoryShow.dateEnd && inventoryShow.dateEnd.date ? moment(inventoryShow.dateEnd.date).format("L") : "-",
          "Dias Para Notificação De Encerramento": inventoryShow.closingNotificationDays ? inventoryShow.closingNotificationDays : "-",
          "Índice de Reajuste": inventoryShow.readjustmentIndex ? this.commonHelper.transcriptReadjustmentQuoeficientGroup(inventoryShow.readjustmentIndex): "-",
          "Data De Reajuste Aplicável": inventoryShow.readjustmentDate && inventoryShow.readjustmentDate.notApplicable ? "SIM" : "NÃO",
          "Data De Reajuste": inventoryShow.readjustmentDate && inventoryShow.readjustmentDate.date ? moment(inventoryShow.readjustmentDate.date).format("L") : "-",
          "Notificatação de Reajuste Aplicável": inventoryShow.daysForNotificationOfReadjustment && inventoryShow.daysForNotificationOfReadjustment.notApplicable ? "SIM" : "NÃO",
          "Dias para Notificação do Reajuste": inventoryShow.daysForNotificationOfReadjustment && inventoryShow.daysForNotificationOfReadjustment.days ? inventoryShow.daysForNotificationOfReadjustment.days : "-",
          "Juros e Multas": inventoryShow.finesAndInterests ? this.commonHelper.transcriptFinesAndInterests(inventoryShow.finesAndInterests) : "-",
          "Porcentagem dos Juros": inventoryShow.interes ? inventoryShow.interes : "-",
          "O Cliente Autoriza a Utilização da Marca": inventoryShow.trademarkUsageClause && inventoryShow.trademarkUsageClause.checkd ? "SIM" : "NÃO",
          "Observação da Cláusula de Uso da Marca": inventoryShow.trademarkUsageClause && inventoryShow.trademarkUsageClause.observation ? inventoryShow.trademarkUsageClause.observation : "-",
          "Não Solicitação de Profissional do Cliente": inventoryShow.consultantRequest && inventoryShow.consultantRequest.checkd ? "SIM" : "NÃO",
          "Observação da Cláusula de Não Solicitação": inventoryShow.consultantRequest && inventoryShow.consultantRequest.observation ? inventoryShow.consultantRequest.observation : "-",
        //   "Responsável do Centro de Excelência": inventoryShow.excellenceCenterResponsible ? inventoryShow.excellenceCenterResponsible.name : "-",
        //   "Responsável do Setor": inventoryShow.industryResponsible ? inventoryShow.industryResponsible.name : "-",
          "Observações": inventoryShow.observation ? inventoryShow.observation : "-",
          "Status": inventoryShow.active ? "Ativo" : "Inativo"
        };
    }),

    `Company-inventory - ${new Date().toLocaleDateString('pt-br')}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/views/companies/company-inventory/companyInventory.component.ts